import { PaymentClientError, PaymentErrorShortCodes } from '..';
var VendorModulesConfig = /** @class */ (function () {
    function VendorModulesConfig() {
    }
    VendorModulesConfig.loadVendorModulesFiles = function () {
        if (typeof isTestPaymentBrowser === 'undefined' && typeof window !== 'undefined') {
            require('../../../vendor_modules/vendor_modules');
        }
        VendorModulesConfig.verifyVendorModulesFilesLoaded();
    };
    VendorModulesConfig.verifyVendorModulesFilesLoaded = function () {
        if (typeof adyen === 'undefined') {
            throw new PaymentClientError('Cannot find vendor module, please make sure to load it', PaymentErrorShortCodes.missing_vendor_library, {
                cause: { message: 'adyen vendor module not loaded' }
            });
        }
        if (typeof forge === 'undefined') {
            throw new PaymentClientError('Cannot find vendor module, please make sure to load it', PaymentErrorShortCodes.missing_vendor_library, {
                cause: { message: 'forge module not loaded' }
            });
        }
        if (typeof INIStdPay === 'undefined') {
            throw new PaymentClientError('Cannot find vendor module, please make sure to load it', PaymentErrorShortCodes.missing_vendor_library, {
                cause: { message: 'INICIS vendor module not loaded' }
            });
        }
    };
    return VendorModulesConfig;
}());
export { VendorModulesConfig };
